import React from 'react';
import DefaultLayout from '../../layouts/default';
import UsersHeader from './components/UsersHeader';
import UserStatsGrid from './components/UserStatsGrid';
import UserManagementTable from './components/UserManagementTable';
import AuditAccessBanner from './components/AuditAccessBanner';
import { UsersProvider } from './context/UsersContext';
export default function UsersPage() {
  return <DefaultLayout><UsersProvider><UsersHeader /><UserStatsGrid /><UserManagementTable /><AuditAccessBanner /></UsersProvider></DefaultLayout>;
}
